import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { EntitateInruditaTypeAddPayload, EntitateInruditaTypeEditPayload } from '../entitate-inrudita-type.interface';
import { EntitateInruditaTypeService } from '../entitate-inrudita-type.service';

@Component({
    selector: 'app-edit-entitate-inrudita-type',
    templateUrl: './edit-entitate-inrudita-type.component.html',
    styleUrls: ['./edit-entitate-inrudita-type.component.scss']
})
export class EditEntitateInruditaTypeComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        description: new FormControl(this.data.description, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditEntitateInruditaTypeComponent>,
        private requestService: EntitateInruditaTypeService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const { name, slug, description } = this.form
            .value as EntitateInruditaTypeAddPayload;
        const payload: EntitateInruditaTypeEditPayload = {
            id: this.data.id,
            name,
            slug,
            description,
        };

        this.requestService
            .updateEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
